import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';

@Component({
  selector: 'app-task',
  templateUrl: './task.component.html',
  styleUrls: ['./task.component.scss']
})
export class TaskComponent implements OnInit {

  @Input() task: AttributeModel
  @Output() onExecute: EventEmitter<AttributeModel> = new EventEmitter()

  constructor() {
  }

  ngOnInit() {
  }

  getClassName(): string {
    let classOpt = this.getOptionValue("class")

    if(classOpt) {
      return classOpt
    } else {
      return "btn btn-primary"
    }
  }

  getCommentFields(): AttributeModel[] {
    return this.task.attributes.filter(attr => attr.type.toLowerCase() == "inputtext")
  }

  getIconClassName(): string {
    return this.getOptionValue("icon-class")
  }

  private getOptionValue(key: string) {
    let options = this.task.options

    if (options) {
      let classOpt = options.find(o => o.key.toLowerCase() == key)

      if (classOpt && classOpt.value) {
        return classOpt.value
      }
    }
  }

  getTaskName(): string {
    if(!this.task) {
      return 'Executar'
    }

    let titleOpt = this.task.options.find(opt => opt.key.toLowerCase() == "title")

    if(titleOpt) {
      return titleOpt.value
    }

    return this.task.key
  }

  execute() {
    this.onExecute.next(this.task)
  }

  isAction() {
    return this.task && this.task.type.toLowerCase().startsWith("action")
  }

  isCompleted(): boolean {
    if(!this.task) {
      return true
    }

    let matchOpt = this.task.options.find(opt => opt.key.toLowerCase() == "match")

    if(matchOpt) {
      return matchOpt.value.toLowerCase() == "true"
    }

    return false
  }
}
